<template>
  <GestionFacturacionElectronica/>
</template>
<script>
import GestionFacturacionElectronica from "@/views/facturacionElectronica/components/GestionFacturacionElectronica.vue";

export default {
  components: {GestionFacturacionElectronica}

}
</script>
